export enum ENUM__field_kind {
  INPUT = 'input',
  OUTPUT = 'output',
}
